import { render, staticRenderFns } from "./CategoryCombinedTemplate.vue?vue&type=template&id=63788a48&scoped=true&"
import script from "./CategoryCombinedTemplate.vue?vue&type=script&lang=js&"
export * from "./CategoryCombinedTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CategoryCombinedTemplate.vue?vue&type=style&index=0&id=63788a48&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63788a48",
  null
  
)

export default component.exports